import { LoadingButton } from "@mui/lab";
import { getUploadErrorMessage, uploadFile } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useRef } from "react";

const FileUpload = ({
  onSuccess,
  onError,
  loading,
  sx,
  onClickCallback,
  forceCategory = null,
}) => {
  const fileInputRef = useRef(null);
  const { openSuccess, openError } = usePopupNotificationContext();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileSelect = async ({ target }) => {
    if (target.files[0] !== undefined) {
      const errors = [];

      if (target.files.length > 0) {
        if (onClickCallback) {
          onClickCallback();
        }
        for (const file of target.files) {
          const multipartFormDataObj = new FormData();

          multipartFormDataObj.append("FileType", file.type);
          multipartFormDataObj.append(
            "Content",
            new Blob([file], { type: file.type }),
            file.name
          );
          multipartFormDataObj.append(
            "Category",
            forceCategory ?? "BANKINBETALNING"
          );

          try {
            await uploadFile(multipartFormDataObj);
          } catch (error) {
            errors.push(
              getUploadErrorMessage(
                error,
                `Ett fel uppstod när ${file.name} skulle laddas upp.`
              )
            );
          }
        }
      }
      if (errors.length > 0) {
        openError(errors.join(" "), 5000);
        if (onError) {
          onError();
        }
      } else {
        openSuccess("Ok!", 3000);
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  };
  return (
    <>
      <LoadingButton
        variant="contained"
        size="small"
        onClick={handleButtonClick}
        loading={loading}
        sx={sx}
      >
        Välj filer
        <input
          ref={fileInputRef}
          type="file"
          multiple
          hidden
          onChange={handleFileSelect}
        />
      </LoadingButton>
    </>
  );
};

export default FileUpload;
